<div class="container">
    <!-- Trigger the modal with a button -->

    <!-- Modal -->
    <div class="modal fade" id="confirmModal" role="dialog">
        <div class="modal-dialog modal-lg">

            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title">{{type}} successful</h4>
                </div>

                <div class="row" id="modal-row">
                    <div class="col-xs-6 form-group">
                        <p id="confirm-type"><b>Type:</b >{{type}}</p>
                    </div>
                    <div class="col-xs-6 form-group">
                        <b>   <p>Customer: </p></b>
                            <p>Full name: {{customers[0]}}</p>
                            <p> Street: {{customers[1]}}</p>
                            <p> Adress: {{customers[2]}}</p>
                            <p> Email: {{customers[4]}} </p>
                            <p>Phone: {{customers[5]}}</p>

                    </div>
                    <div class="col-xs-6">
                        <div class="row">
                            <p class="col-xs-12"><b>From: </b>{{fromAirport}}, <b>To:</b> {{toAirport}}</p>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <p>Total price:</p>
                                <p>{{totalPriceString}}</p>
                            </div>
                            <div class="col-xs-12 col-sm-6">
                                <p>Travel period:</p>
                                <p>{{travelPeriod}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6 form-group">
                        <p>Participants:</p>
                        <p *ngFor="let participant of participants; let i= index;">
                            {{i+1}}. {{participant.salutation}} {{participant.firstName}} {{participant.lastName}} {{participant.birthdayAsString}}
                        </p>
                    </div>
                </div>

                <!-- /.row -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" data-dismiss="modal">Close</button>
                </div>
            </div>

        </div>
    </div>

</div>


// WEBPACK FOOTER //
// ./src/app/shared-components/confirm.component.html